import { render, staticRenderFns } from "./ModalHandler.vue?vue&type=template&id=b6049136&"
import script from "./ModalHandler.vue?vue&type=script&lang=ts&"
export * from "./ModalHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports